import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VersionControlService {
  public showVersionPopup$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  public triggerVersionMismatch() {
    this.showVersionPopup$.next(true);
  }
}
